import { create } from "@bufbuild/protobuf";
import { createFileRoute, useParams } from "@tanstack/react-router";

import { GetProjectRequestSchema } from "@gx/ts-contracts/services/ontology/api/project_pb";

import ProjectSettingsPage from "@/pages/projects/components/project/settings/ProjectSettingsPage";

import { useGetProjectQuery } from "@/api/queries/projects";

export const Route = createFileRoute("/_secure/projects/$projectId/settings/general")({
  component: RouteComponent,
});

function RouteComponent() {
  const { projectId } = useParams({ from: "/_secure/projects/$projectId/settings/general" });

  const { data: project } = useGetProjectQuery({
    input: create(GetProjectRequestSchema, { projectId }),
  });

  if (!project?.project) {
    return null;
  }

  return (
    <ProjectSettingsPage project={project.project} route="/projects/$projectId/settings/general" />
  );
}
